import styled from 'styled-components'

export const DashboardAuthLayoutWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const DashboardAuthLayoutContent = styled.main`
  width: calc(100% - 56px);
  padding: 24px;
  background: #f2f3f8;
  left: 56px;
  position: relative;
  min-height: 100vh;
`
